// determines whether the STATUS facet field should
// render the single branch alternative
export default ({ currentScopeId, isLibrarySingleBranch, isLibraryScopeFacetEnabled, libraryScopes }) => {
  if (!isLibrarySingleBranch) {
    return false;
  }

  const isLastChildScope =
    libraryScopes.length > 1 && !libraryScopes.find(scope => scope.parentScopeId === currentScopeId);

  return !isLibraryScopeFacetEnabled || isLastChildScope;
};
